import { POSTHOG_FEATURES } from "../constants/feature-flags"
import usePostHogFeatureFlags from "./posthog-feaures"

export default function useChatbotAccess() {
  const isFeatureFlagEnabled = usePostHogFeatureFlags(POSTHOG_FEATURES.CHATBOT)
  return isFeatureFlagEnabled
}
